// extracted by mini-css-extract-plugin
export default {"sub":"css_sub__MtReU"};